export const dictPermissions: { [key: string]: any } = Object.freeze({
  module_soat_link: 906,
  module_soat_venta: 907,
});

export const listPermissions = Object.keys(dictPermissions).map(
  (key: string) => dictPermissions[key]
);

export const dictPermissionsGestion: { [key: string]: any } = Object.freeze({
  module_soat_consulta_movimientos: 908,
});

export const listPermissionsGestion = Object.keys(dictPermissionsGestion).map(
  (key: string) => dictPermissionsGestion[key]
);
